import './wallet-management.css'

import NiceModal, { useModal } from '@ebay/nice-modal-react'
import { lazy, Suspense } from 'react'
import { useTranslation } from 'react-i18next'
import { Portal } from 'react-portal'

import useDimensions from '../../hooks/useDimensions'
import closeModal from '../../utils/closeModal'
import { Backdrop, Spinner } from '../common'
import Icon from '../icon'

const Withdraw = lazy(() => import('./withdraw'))

const WithdrawModal = () => {
  const { isDesktop } = useDimensions()
  const modal = useModal()
  const { t } = useTranslation('walletManagement')

  return (
    <Portal>
      {isDesktop && (
        <Backdrop
          zIndex={203}
          isVisible={modal.visible}
          onClick={() => closeModal(modal)}
          aria-label="Close withdraw modal"
        />
      )}
      <div
        id="withdraw-modal"
       className="withdraw-modal-container w-full h-dvh max-w-[1100px] bg-primary dark:bg-primary-bg dark:bg-size-primary-bg z-[204] fixed p-0 rounded-none border-0 left-0 top-0 xl:-translate-x-2/4 xl:-translate-y-2/4 xl:h-[unset] xl:max-h-[880px] xl:overflow-y-auto xl:rounded-xl xl:left-2/4 xl:top-2/4">
        <div className="flex mb-5">
          <div className="bg-primary flx-ctr flex-1 h-10 font-medium uppercase text-base text-txt xl:text-lg xl:h-[50px] xl:rounded-tl-[10px]">
            {t('withdrawal')}
          </div>
          <button
            className="flx-ctr text-highlight underline bg-highlight px-4 py-2 xl:rounded-tr-[10px]"
            onClick={() => closeModal(modal)}
            aria-label="Close modal">
            <Icon
              className="fill-white w-3.5 h-3.5"
              id="close"
              width={12}
              height={12}
            />
          </button>
        </div>
        <Suspense fallback={<Spinner containerStyle={{ padding: '36px 0' }} />}>
          <Withdraw />
        </Suspense>
      </div>
    </Portal>
  )
}

export default NiceModal.create(WithdrawModal)
